import { useState } from "react";
import { Link } from "react-router-dom";
import { ListChecks, X, MessageCircle, Trash2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { WHATSAPP_NUMBER } from "@/lib/api";
import { thumb } from "@/lib/img";

export default function ServiceSelectionSummary() {
  const { serviceSelection, toggleServiceSelection, clearServiceSelection } = useApp();
  const [open, setOpen] = useState(false);
  if (!serviceSelection.length) return null;
  const msg = `Hello Tent N Tap,\n\nI've shortlisted these services (${serviceSelection.length}):\n${serviceSelection.map((s, i) => `${i + 1}. ${s.name}`).join("\n")}\n\nPlease share availability and pricing.`;
  const wa = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

  return (
    <>
      <button type="button" data-testid="service-selection-pill" onClick={() => setOpen(true)}
        className="fixed right-4 bottom-24 lg:bottom-6 z-40 inline-flex items-center gap-2 rounded-full bg-[#292724] text-[#f4e5b7] pl-3 pr-4 py-2.5 text-xs tracking-[0.12em] uppercase shadow-[0_14px_40px_-12px_rgba(41,39,36,0.7)] hover:-translate-y-0.5 transition-transform">
        <ListChecks className="w-4 h-4" /> Selection <span className="rounded-full bg-[#d4af37] text-[#292724] w-5 h-5 flex items-center justify-center text-[10px] font-semibold">{serviceSelection.length}</span>
      </button>
      {open && (
        <div data-testid="service-selection-sheet" className="fixed inset-0 z-[90] bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-6" onClick={() => setOpen(false)}>
          <div className="w-full sm:max-w-md bg-[#fdfbf7] rounded-t-3xl sm:rounded-3xl p-6 shadow-2xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between gap-3 mb-4">
              <div>
                <div className="eyebrow">Your selection</div>
                <h3 className="font-serif text-2xl text-[#292724]">Shortlisted services</h3>
              </div>
              <button type="button" aria-label="Close" data-testid="service-selection-close" onClick={() => setOpen(false)} className="p-2 rounded-full hover:bg-[#f4e5b7]/60"><X className="w-5 h-5" /></button>
            </div>
            <ul className="space-y-2 overflow-y-auto flex-1">
              {serviceSelection.map((s) => (
                <li key={s.id} data-testid={`service-selection-item-${s.id}`} className="flex items-center gap-3 card-lux !p-3">
                  <div className="w-12 h-12 rounded-xl overflow-hidden bg-[#faf7f2] border border-[#ebe6e0] shrink-0">{s.image && <img src={thumb(s.image, 200)} alt="" className="w-full h-full object-cover" />}</div>
                  <Link to={`/services/${s.id}`} onClick={() => setOpen(false)} className="flex-1 font-serif text-base text-[#292724] hover:text-[#b8912a] truncate">{s.name}</Link>
                  <button type="button" aria-label="Remove" data-testid={`service-selection-remove-${s.id}`} onClick={() => toggleServiceSelection(s)} className="p-2 rounded-full text-[#8a837a] hover:text-red-600 hover:bg-red-50"><Trash2 className="w-4 h-4" /></button>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex flex-col sm:flex-row gap-2">
              <a href={wa} target="_blank" rel="noreferrer" data-testid="service-selection-whatsapp" className="btn-whatsapp justify-center flex-1"><MessageCircle className="w-4 h-4" /> Send on WhatsApp</a>
              <button type="button" data-testid="service-selection-clear" onClick={() => { clearServiceSelection(); setOpen(false); }} className="btn-outline-gold justify-center">Clear</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
